import { mapActions, mapState } from "vuex";
import EventBus from "../../shared/utils/event_bus";

export default {
  data() {
    return {
      notify: null,
      statusExec: false,
    };
  },

  computed: {
    ...mapState({
      selectedAccount: (state) => state.accountTypes.selectedAccount,
      masks: (state) => state.investment.masks,
    }),
  },

  methods: {
    ...mapActions({
      getInvestments: "investment/getInvestments",
      snapshotEvent: "eventAndNotification/snapshotEvent",
      positionStream: "stream/positionStream",
      orderStream: "stream/orderStream",
      QtdPositionStream: "stream/qtdPositionStream",
      notificationStream: "notification/notificationStream",
      notificationAll: "notification/notificationAll",
      addMask: "investment/addMask",
      messageWebsocketInvestmentStart: "investment/messageWebsocketInvestmentStart",
      messageWebsocketInvestmentStop: "investment/messageWebsocketInvestmentStop",
      closeBest: "bests/closeBest",
    }),

    execEvent(message) {
      this.saveEvent(message)
        .then((response) => {
          switch (response.type) {
            case "NEW_POSITION":

            case "UPDATE_POSITION":
              if (this.$route.name == "Investimentos") {
                this.messageWebsocketInvestmentStart({
                  message: message.data[0],
                  account_id: this.selectedAccount.account_id,
                });
              }
              this.positionStream(message);
              this.notificationStream(message);

              break;
            case "POSITION_CLOSE":
              // console.log(message);
              if (this.$route.name == "Investimentos") {
                this.messageWebsocketInvestmentStop({
                  message: message.data[0],
                  account_id: this.selectedAccount.account_id,
                });
              }
              this.positionStream(message);
              this.notificationStream(message);

              break;
            case "NEW_ORDER":
            case "UPDATE_ORDER":
            case "ORDER_CLOSE":
              this.orderStream(message);
              break;
          }
          // console.log(message, response)
          if (this.masks.includes(response.type)) {
            this.addMask(message);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },

  created() {
    EventBus.$on("NOTIFICATION", (e) => {
      this.notificationAll(e);
    });
    EventBus.$on("EVENT", (e) => {
      this.execEvent(e);
    });
    EventBus.$on("BEST", (e) => {
      // console.log(e);

      this.closeBest(e);
    });
  },

  unmounted() {
    if (this.notify != null) {
      this.notify.stop();
      this.notify = null;
    }
  },
};
